// eslint-disable-next-line import/prefer-default-export
export const slipNameValidator = value => /^[\d\w\s]{0,17}$/.test(value);
